<template>
  <div class="main-contents">

    <header>
      <div class="header-top-inner">
        <a href="/">
          <div class="item">
            <h1>ハワイPCR検査センター</h1>
            <!--<p>HAWAII PCR CENTER</p>-->
          </div>
        </a>
        <div class="item cv">
          <ul>
            <a href="https://lin.ee/BXdbFKG"><li>お問い合わせはこちら</li></a>
            <a href="javaScript:void(0)" onclick="alert('現在、サービス提供を終了しております。')"><li class="contact-btn">お申し込み</li></a>
          </ul>
        </div>
      </div>
      <!--
      <div class="header-bottom-inner">
        <div class="btn-inner">
          <div id="btn01" class="item selected" v-on:click="btn01">来店検査</div>
          <div id="btn02" class="item" v-on:click="btn02">ホテル訪問検査</div>
        </div>
      </div>-->
    </header>
    <div id="content01" class="content show">
      <h2>お申込みフォーム</h2>
      <div id="waikiki">
       <img src="../assets/mv-test-sp20230407.png" class="pcnone">
          <img src="../assets/mv-test-pc20230407.png" class="spnone">
      </div>
      <div id="aramoana">
      <img src="../assets/mv-test-sp20230407.png" class="pcnone">
          <img src="../assets/mv-test-pc20230407.png" class="spnone">
        <!--
        <img src="../assets/top-sp2.png" class="pcnone">
        <img src="../assets/top-pc2.png" class="spnone">
      -->
      </div>
      <h2>基本情報</h2>
      <p class="caution">※帰国日時や希望日時は現地時刻を意味します。</p>
      <form action="#" method="post" onsubmit="return false;">
         <div class="Form" id="form">
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>氏名</p>
            <input type="text" v-model="name" name="name" class="Form-Item-Input" placeholder="例）山田太郎">
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>電話番号</p>
            <input type="text" v-model="tel" name="tel" class="Form-Item-Input" placeholder="例）000-0000-0000">
          </div>
          <!--パスポート番号-->
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>パスポート番号</p>
            <input type="text" v-model="passport" name="passport" class="Form-Item-Input" placeholder="例）XS1234567">
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>メールアドレス</p>
            <input type="email" name="mail" v-model="mail" class="Form-Item-Input" placeholder="例）example@gmail.com" >
          </div>
          <!--人数-->

          <div class="Form-Item" style="border-bottom: 0px solid #ddd;">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>検査人数</p>

            <select name="amount" id="" class="Form-Item-Input" @change="selectamount" v-model="amount">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7名以上">7名以上</option>
            </select>
          </div>
          <div class="Form-Item" style="border-top: 0px solid #ddd;margin: 0 auto;display: block; text-align: left;">
             <p>※7名以上のお問合せは、<a href="https://lin.ee/BXdbFKG" style="color: red;font-weight: bold;">Line</a>でお問合せくださいませ。</p>
          </div>
            
          <!--名前・パスポート番号-->
          <div class="" v-if="amount == '1'">
          </div>
          <div class="" v-else-if="amount == '7名以上'">
          </div>
          <div class="" v-else>
            <div class="Form-Item">
              <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>同行される方の情報</p>
              <ul class="cutomerListInner">
                <li v-for="(customer, index) in customers">
                  <p class="number">{{ index+2 }}人目</p>
                  <p class="Form-Item-Label">氏名</p>
                  <input type="text" v-model="customer.name" name="name" class="Form-Item-Input" placeholder="例）山田太郎">
                  <p class="Form-Item-Label">パスポート番号</p>
                  <input type="text" v-model="customer.passport" name="passport" class="Form-Item-Input" placeholder="例）XS1234567">
                </li>
              </ul>
            </div>
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>検査場所</p>
            <select name="place" id="" class="Form-Item-Input" @change="selectplace" v-model="place">
                <option value="ワイキキ">ワイキキ</option>
            </select>
          </div>
          <div class="Form-Item" style="border-top: 0px solid #ddd;margin: 0 auto;display: block;">
             <p style="text-align: left;">※現在、アラモアナは予約を受け付けておりません。ご不明点ございましたら<a href="https://lin.ee/BXdbFKG" style="color: red;font-weight: bold;">Line</a>でお問合せくださいませ。</p>
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>帰国日</p>
            <vuejs-datepicker
    :language="ja"
    v-model="date"
    :value="this.default"
    :format="DatePickerFormat"
    :id="el"
    @closed="dateselected"
    :disabled-dates="disabledDates"
     ></vuejs-datepicker>
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>帰国便出発予定時間</p>
            <div class="time" style="text-align: left;width: inherit;">
              <select name="selecthour" id="selectedate-h" class="Form-Item-Input" style="width: 30%;" @change="selecthour" v-model="hour">
                <option value="00">00</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
              </select>時
              <select name="selectminute" id="selectedate-m" class="Form-Item-Input" style="width: 30%;" @change="selectminute" v-model="minute">
                <option value="00">00</option>
                <option value="05">05</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
                <option value="35">35</option>
                <option value="40">40</option>
                <option value="45">45</option>
                <option value="50">50</option>
                <option value="55">55</option>
              </select>分
            </div>
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label">帰国便名</p>
            <input type="text" name="airplane" class="Form-Item-Input" placeholder="例）JL071" v-model="airplane">
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>検査テストの種類</p>
            <select name="test" id="" class="Form-Item-Input" @change="selecttest" v-model="test">
                <option value="通常検査(6時間以内)">通常検査(6時間以内)</option>
                <option value="30分最速プラン">30分最速プラン(30分以内)</option>
            </select>
          </div>
          <!--検査希望日時(検査場所と帰国日と帰国便名を選択すると可能なカレンダーが表示、日付を選択すると時間帯の選択肢ボタン)<必須>-->
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>検査希望日時</p>
            <v-calendar :disabled-dates='{}' :available-dates="dates"></v-calendar>
          </div>
          <div class="">
              <p style="font-weight: bold; color: orange;">上記カレンダーの太字が当日を除く、帰国前72時間以内の範囲で受検可能なお日にちになります。<br>以下の選択肢からご希望検査日時をお選びください。</p>
              <p v-html="alert" style="font-weight: bold; color: red;"></p>
              <div class="time-button-inner">
                <div class="">
                  <select name="selectedtestDate" id="selectedtestDate" class="Form-Item-Input"  @change="selectTestDate" v-model="testDate">
                  </select>
                </div>
              </div>
          </div>
          <!--
          <div class="Form-Item">
            <p class="Form-Item-Label isMsg">その他備考</p>
            <textarea class="Form-Item-Textarea" name="memo" v-model="memo"></textarea>
          </div>-->
<!--
          <h2>決済情報</h2>
          <p class="caution"></p>
          <div class="Form-Item" id="card-num">
             <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>クレジットカード番号</p>
             <input class="Form-Item-Input" id="ff1_input" type="text" maxlength="4" placeholder="0000" name="cno" autofocus  v-model="cardNum1"/>
             <input class="Form-Item-Input" type="text" maxlength="4" placeholder="0000" name="cno" v-model="cardNum2"/>
             <input class="Form-Item-Input" type="text" maxlength="4" placeholder="0000" name="cno" v-model="cardNum3"/>
             <input class="Form-Item-Input" type="text" maxlength="4" placeholder="0000" name="cno" v-model="cardNum4"/>
          </div>
          <div class="Form-Item">
             <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>お名前</p>
             <input class="Form-Item-Input" id="ff2_input" type="text" placeholder="First Name"  v-model="cardFirstName"/>
             <input class="Form-Item-Input" type="text" placeholder="Last Name" v-model="cardLastName"/>
           </div>
           <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>期限月/年</p>
            <select class="Form-Item-Input" id="month" v-model="cardMonth">
              <option value="01">01</option>
              <option value="02">02</option>
              <option value="03">03</option>
              <option value="04">04</option>
              <option value="05">05</option>
              <option value="06">06</option>
              <option value="07">07</option>
              <option value="08">08</option>
              <option value="09">09</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
            <select class="Form-Item-Input" id="year" v-model="cardYear">
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
              <option value="24">24</option>
              <option value="25">25</option>
              <option value="26">26</option>
              <option value="27">27</option>
              <option value="28">28</option>
              <option value="29">29</option>
              <option value="30">30</option>
              <option value="31">31</option>
              <option value="32">32</option>
              <option value="33">33</option>
              <option value="34">34</option>
              <option value="35">35</option>
              <option value="36">36</option>
              <option value="37">37</option>
              <option value="38">38</option>
              <option value="39">39</option>
              <option value="40">40</option>
            </select>
           </div>
           <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>セキュリティコード</p>
            <input class="Form-Item-Input" id="ff4_input" type="text" maxlength="3" placeholder="000" v-model="cvc"/>
          </div>-->
          <div class="policy">
            <input type="checkbox" id="consent-chk" name="consent-chk"  v-model="checked" v-on:change="onChange(checked)">
            <label for="consent-chk">以下のキャンセルポリシーに同意する</label>
            <div class="box">
              <p>キャンセルポリシーについて<br><br>検査日から1週間以内でのキャンセル・返金は如何なる理由でも受付しておりません、万が一キャンセルされる場合は1週間前までにご連絡をこちらのメールに連絡ください。事務局からご連絡いたします。(info@hawaii-pcr-concierge.com)<br>ただし政府等の意向により検査が必要なくなった場合は返金をさせていただきます。<br>※返金レートは1ドル130円で計算いたします。</p>
            </div>
          </div>
          <button v-on:click="toconfirm" class="Form-Btn" id="confirm-btn">確認する</button>
          <a href="/" style="color: gray;margin: 5% auto;display: block;">トップへ戻る</a>
        </div>

         <div class="Form" id="confirm">
          <p class="caution" style="color: red; font-weight: bold; font-size: 2em;">注意：お申し込みはまだ完了しておりません</p>
          <table class="table">
            <tr>
              <th>氏名</th>
              <td>{{ name }}</td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td>{{ tel }}</td>
            </tr>
            <tr>
              <th>パスポート番号</th>
              <td>{{ passport }}</td>
            </tr>
            <tr>
              <th>メールアドレス</th>
              <td>{{ mail }}</td>
            </tr>
            <tr>
              <th>検査人数</th>
              <td>{{ amount }}</td>
            </tr>
            <tr>
              <th>同行される方の情報</th>
              <td>
                <ul class="cutomerListInner">
                  <li v-for="(customer, index) in customers">
                    <p class="number">{{ index+2 }}人目</p>
                    <p>{{ customer.name }}</p>
                    <p>{{ customer.passport }}</p>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>検査場所</th>
              <td>{{ place }}</td>
            </tr>
            <tr>
              <th>帰国日</th>
              <td id="date-confirm">{{ dateString }}</td>
            </tr>
            <tr>
              <th>帰国便出発予定時間</th>
              <td>{{ hour }} ： {{ minute }}</td>
            </tr>
            <tr>
              <th>帰国便名</th>
              <td>{{ airplane }}</td>
            </tr>
            <tr>
              <th>検査テストの種類</th>
              <td>{{ test }}</td>
            </tr>
            <tr>
              <th>検査希望日時</th>
              <td>{{ testDate }}</td>
            </tr>
            <!--
            <tr>
              <th>その他備考</th>
              <td>{{ memo }}</td>
            </tr>-->
            <tr>
              <th>合計検査料金</th>
              <td>{{ price }}</td>
            </tr>
          </table>
          <!--
          <h2>決済情報</h2>
          <p class="caution"></p>
          <table class="table">
            <tr>
              <th>クレジットカード番号</th>
              <td>＊＊＊＊ ＊＊＊＊ ＊＊＊＊{{ cardNum4 }}</td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td>{{ tel }}</td>
            </tr>
            <tr>
              <th>パスポート番号</th>
              <td>{{ passport }}</td>
            </tr>
            <tr>
              <th>メールアドレス</th>
              <td>{{ mail }}</td>
            </tr>
          </table>-->
          <p class="caution" style="text-align: left; line-height: 2em;">※決済は未完了ですので遷移先の決済画面でクレジットカード情報を入力して、決済を完了してください。決済完了後に決済完了メールも届きます。</p>
          <input type="hidden" name="g-recaptcha-response" id="g-recaptcha-response">
          <button v-on:click.once="tosend" class="Form-Btn">決済画面へ</button>
          <button v-on:click="toform" class="Form-Btn">前へ戻る</button>
          <a href="/" style="color: gray; margin: 5% auto;display: block;">トップへ戻る</a>
        </div>
      </form>
    </div>
    <div id="content02" class="content">

    </div>
    <footer style="text-align: center;">
      Copyright © 2022 Kirarin.Co.,Ltd.
    </footer>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/vue/2.6.10/vue.min.js"></script>
<script src='https://unpkg.com/v-calendar'></script>

<script src="https://cdn.jsdelivr.net/npm/fullcalendar@5.5.0/main.min.js"></script>
<script type="text/javascript">
  window.onload = function(){
    // contentクラスの1つ目にshowを入れる
    document.getElementById("content01").classList.add("show");
  }
</script>
<script src="https://www.google.com/recaptcha/api.js?render=6Le9MRIiAAAAAKEXL43Pl4JPSBa5y0ZfzO9ZvYzA"></script> 
<script>
grecaptcha.ready(function() {
    grecaptcha.execute('6Le9MRIiAAAAAKEXL43Pl4JPSBa5y0ZfzO9ZvYzA', {action: 'homepage'}).then(function(token) {
        var recaptchaResponse = document.getElementById('g-recaptcha-response');
        recaptchaResponse.value = token;
    });
});
</script>

<script>
import vuejsDatepicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'Top',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      id: "",
      default: '2018-10-04',
      ja:ja,
      name: '',
      tel: '',
      mail: '',
      date: null,
      dateString: '',
      place: '',
      passport: '',
      amount: null,
      customers: [],
      hour: '--',
      minute: '--',
      airplane: '入力なし',
      memo: '',
      tomorrow: null,
      cardNum1: null,
      cardNum2: null,
      cardNum3: null,
      cardNum4: null,
      isCampaign: null,
      price: null,
      verprice: null,
      cardFirstName: null,
      cardLastName: null,
      cardMonth: null,
      cardYear: null,
      cvc: null,
      checked: false,
      DatePickerFormat: 'yyyy-MM-dd',
      selectedDate: new Date(),
      testDate: null,
      test: null,
      dates: [],
      selectDates: [],
      dateStrings: [],
      alert: '',
      disabledDates: {
      to: new Date(new Date().setDate(new Date().getDate() + 1)),
      from: new Date(2023,4,7)

      },
      attrs: [
          {
            key: 'today',
            highlight: {
              backgroundColor: '#ff8080',
            },
            dates:new Date()
            ,
            popover: {
              label: 'メッセージを表示できます',
            },
          }
      ],
      mode: 'single',
      formats: {
          input: ['YYYY-MM-DD'],
      }
    }
  },
  components: {
    'vuejs-datepicker':vuejsDatepicker
  },
  methods: {
    btn01: function () {
      document.getElementById("btn02").classList.remove("selected");
      document.getElementById("btn01").classList.add("selected");
      document.getElementById("content01").classList.add("show");
      document.getElementById("content02").classList.remove("show");
    },
     onChange: function(checked) {
      if (checked) {
        /*
         document.getElementById("confirm-btn").style.opacity = 1;
         document.getElementById("confirm-btn").disabled = false;*/
         document.getElementById("confirm-btn").style.opacity = 1;
         //document.getElementById("confirm-btn").classList.add('confirm-btn-disable');
         
      } else {
        /*
         document.getElementById("confirm-btn").style.opacity = 0.6;
         document.getElementById("confirm-btn").disabled = true;*/
         document.getElementById("confirm-btn").style.opacity = 0.6;
        // document.getElementById("confirm-btn").classList.remove('confirm-btn-disable');


         

         
      }
    },
    btn02: function () {
      document.getElementById("btn01").classList.remove("selected");
      document.getElementById("btn02").classList.add("selected");
      document.getElementById("content01").classList.remove("show");
      document.getElementById("content02").classList.add("show");
    },
    dateselected: function () {
      //console.log(this.date)
      // 帰国日・場所・帰国便出発予定時間からカレンダーの選択できる時間を自動指定
      //datesに可能な日にちを"YYYY-MM-DD"の文字列でで配列追加
      this.setAvailableDates()
      console.log(this.selectedDate)

    },
    selectplace: function () {
      //console.log(this.place)
      //datesに可能な日にちを"YYYY-MM-DD"の文字列でで配列追加
      //ワイキキ
      if (this.place === "ワイキキ") {
        document.getElementById("aramoana").style.display = "none";
        document.getElementById("waikiki").style.display = "block";
      } else {
        document.getElementById("waikiki").style.display = "none";
        document.getElementById("aramoana").style.display = "block";
      }
      //アラモアナ
      this.setAvailableDates()
    },
    selectamount: function () {
      console.log("ここ呼ばれてる")
      console.log(this.amount)
      this.customers = []
      let self = this;
      switch (this.amount) {
        case "1":
          //ここでは本人以外を記載する必要はない
          break;
        case "2":
          //ここでは本人以外1人分を記載する必要がある
          for (let i = 0; i < 1; i++) {
            var user = { name: null, passport: null };
            self.customers.push(user);
            console.log(user)
          }
          console.log(self.customers)
          break;
        case "3":
          for (let i = 0; i < 2; i++) {
            var user = { name: null, passport: null };
            self.customers.push(user);
          }
          break;
        case "4":
          for (let i = 0; i < 3; i++) {
            var user = { name: null, passport: null };
            self.customers.push(user);
          }
          break;
        case "5":
          for (let i = 0; i < 4; i++) {
            var user = { name: null, passport: null };
            self.customers.push(user);
          }
          break;
        case "6":
          for (let i = 0; i < 5; i++) {
            var user = { name: null, passport: null };
            self.customers.push(user);
          }
          break;
        case "7名以上":
           alert('検査人数が7名以上の場合は、TOPページのLineからご相談ください。')
          break;
        default:
        console.log("ここはこない");
      }
    },
    selecthour: function () {
      //console.log(this.hour)
      //datesに可能な日にちを"YYYY-MM-DD"の文字列でで配列追加
      this.setAvailableDates()
    },
    selectminute: function () {
      //console.log(this.minute)
      //datesに可能な日にちを"YYYY-MM-DD"の文字列でで配列追加
      this.setAvailableDates()
    },
    setAvailableDates: function () {
      let self = this
      //カレンダ配列クリア
      this.dates = []
      // 帰国日の指定があるかどうか
      if (!this.date) {
        console.log('帰国日の指定がありません')
        this.alert = '帰国日の指定がありません'
      } else {
        //場所が未指定なら午前・午後(8:30~18:00)
        if (this.place === '--選択してください--') {
          this.alert = '場所の指定がありません'
        }
        //場所がワイキキなら午後以降
        if (this.place === 'ワイキキ') {
          console.log(this.place)
          //時間未指定
          if (this.hour === '--') {
            this.alert = '帰国便出発予定時間の時の指定がありません'
          } else {
            if (this.minute === '--') {
              this.alert = '帰国便出発予定時間の分の指定がありません'
            } else {
              // カレンダー選択可能な日にちと時間を計算
              this.alert = ''
              var min = null
              var max = null
              ////帰国日時の24時間前から72時間の日付と時間を抽出(maxとmin)
              //①帰国日時の日付型を取得②帰国日時の72時間前と24時間前の日時を日付型で取得
              let getDateFor24 = this.getParticularDate(this.date, this.hour, this.minute, 1)
              let getDateFor72 = this.getParticularDate(this.date, this.hour, this.minute, 3)
              console.log(getDateFor24)
              console.log(getDateFor72)
              //③72時間前以前24時間前以降で営業時間内のminとmaxを抽出
              ////72時間前以前
              /////開始時間前または終了時間以降であれば翌日の8:30~にする
              //////8:00~8:29または0:00~7:00または18:00~0:00に含まれるかどうか含まれるのであれば
              if (getDateFor72.getHours() === 8 && getDateFor72.getMinutes() < 30) {
                //8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 0)
              } else if (getDateFor72.getHours() <= 8) {
                //8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 0)

              } else if (getDateFor72.getHours() > 17) {
                //翌日8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 1)

              } else {
                //その時間帯がmin
                min = getDateFor72
              }

              ////24時間前以降
              /////開始時間前または終了時間以降であれば前日の18:00にする
              if (getDateFor24.getHours() === 8 && getDateFor24.getMinutes() < 30) {
                //前日18:00がmax
                max = this.getParticularDate(getDateFor24, 18, 0, 0)
              } else if (getDateFor24.getHours() <= 8) {
                //前日18:00がmax
                max = this.getParticularDate(getDateFor24, 18, 0, 1)

              } else if (getDateFor24.getHours() > 17) {
                //当日18:00がmin
                max = this.getParticularPlusDate(getDateFor24, 18, 0, 0)

              } else {
                //その時間帯がmin
                max = getDateFor24
              }

              //④minとmaxの間の差分
              var difminmax = Math.floor((max - min) / 86400000);
              console.log("maxとmin---------")
              console.log(min)
              console.log(max)
              console.log(difminmax)
              console.log("------------------")
              //⑤minにfor文で足した日付(YYYY/MM/DD)をdatesに格納してカレンダー反映
              var a = min
              var b = max
              for (let i = 0; i <= difminmax; i++) {
                console.log(a)
                //var c = this.getParticularPlusDate(a, a.getHours(),a.getMinutes(),i)
                var c = this.getParticularPlusDate(a, a.getHours(),a.getMinutes(),i)
                console.log(c)
                var d = this.getDateStringFromDate(c)
                console.log(d)
                //id-2022-07-16
                //その時間帯がmin
                  let today = new Date();
                  today.setHours(0);
                  today.setMinutes(0);
                  today.setSeconds(0);
                  today.setMilliseconds(0);
                  const begin = today.getTime();

                  // 明日0時　ミリ秒
                  let nextday = new Date();
                  nextday.setDate(nextday.getDate() + 1);
                  nextday.setHours(0);
                  nextday.setMinutes(0);
                  nextday.setSeconds(0);
                  nextday.setMilliseconds(0);
                  const end = nextday.getTime();

                  if (c >= begin && c < nextday ) {

                  } else {
                    this.dates.push(d)
                  }

              }
              //#selectedtestDateに候補を"YYYY/MM/DD HH:DD~"で選択肢<option></option>を追加する
              ////minとmaxの間の15分を足していく(その際営業時間外出ないかチェックをする)
              ////minとmaxの日付の15分単位差分
              //var difminmaxBy15 = Math.floor((max - min) / 900000);
              var difminmaxBy15 = Math.floor((max - min) / 1800000);
              console.log(difminmaxBy15)

              let element = document.getElementById("selectedtestDate");
              while (element.firstChild) {
                element.removeChild(element.firstChild);
              }

              for (let m = 0; m <= difminmaxBy15; m++) {
                var selectValue = this.getParticularPlusMinute(min,m*30)

                //ここでスクリーニング
                if (selectValue.getHours() === 8 && selectValue.getMinutes() < 30) {
                } else if (selectValue.getHours() < 8) {
                } else if (selectValue.getHours() > 17) {
                } else {



                  //その時間帯がmin
                  let today = new Date();
                  today.setHours(0);
                  today.setMinutes(0);
                  today.setSeconds(0);
                  today.setMilliseconds(0);
                  const begin = today.getTime();

                  // 明日0時　ミリ秒
                  let nextday = new Date();
                  nextday.setDate(nextday.getDate() + 1);
                  nextday.setHours(0);
                  nextday.setMinutes(0);
                  nextday.setSeconds(0);
                  nextday.setMilliseconds(0);
                  const end = nextday.getTime();





                  if (selectValue >= begin && selectValue < nextday ) {

                  } else {


                     if (selectValue.getHours() >= 8 && selectValue.getHours() < 12) {

                     } else {

                      var selectValueString = this.getDateHourMinuteStringFromDate(selectValue)
                      self.selectDates.push(selectValue)
                      var select = document.getElementById("selectedtestDate");
                      var option = document.createElement("option");
                      option.text = selectValueString;
                      option.value = selectValueString;
                      self.dateStrings.push(selectValueString);
                      select.appendChild(option);

                     }
                  }
                }
              }
            }
          }
        }
        //場所がアラモアナなら終日OK
        if (this.place === 'アラモアナ') {
          console.log(this.place)
          //時間未指定
          if (this.hour === '--') {
            this.alert = '帰国便出発予定時間の時の指定がありません'
          } else {
            if (this.minute === '--') {
              this.alert = '帰国便出発予定時間の分の指定がありません'
            } else {
              // カレンダー選択可能な日にちと時間を計算
              this.alert = ''
              var min = null
              var max = null
              ////帰国日時の24時間前から72時間の日付と時間を抽出(maxとmin)
              //①帰国日時の日付型を取得②帰国日時の72時間前と24時間前の日時を日付型で取得
              let getDateFor24 = this.getParticularDate(this.date, this.hour, this.minute, 1)
              let getDateFor72 = this.getParticularDate(this.date, this.hour, this.minute, 3)
              console.log(getDateFor24)
              console.log(getDateFor72)
              //③72時間前以前24時間前以降で営業時間内のminとmaxを抽出
              ////72時間前以前
              /////開始時間前または終了時間以降であれば翌日の8:30~にする
              //////8:00~8:29または0:00~7:00または18:00~0:00に含まれるかどうか含まれるのであれば
              if (getDateFor72.getHours() === 8 && getDateFor72.getMinutes() < 30) {
                //8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 0)
              } else if (getDateFor72.getHours() <= 8) {
                //8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 0)

              } else if (getDateFor72.getHours() > 17) {
                //翌日8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 1)

              } else {
                //その時間帯がmin
                min = getDateFor72
              }

              ////24時間前以降
              /////開始時間前または終了時間以降であれば前日の18:00にする
              if (getDateFor24.getHours() === 8 && getDateFor24.getMinutes() < 30) {
                //前日18:00がmax
                max = this.getParticularDate(getDateFor24, 18, 0, 0)
              } else if (getDateFor24.getHours() <= 8) {
                //前日18:00がmax
                max = this.getParticularDate(getDateFor24, 18, 0, 1)

              } else if (getDateFor24.getHours() > 17) {
                //当日18:00がmin
                max = this.getParticularPlusDate(getDateFor24, 18, 0, 0)

              } else {
                //その時間帯がmin
                max = getDateFor24
              }

              //④minとmaxの間の差分
              var difminmax = Math.floor((max - min) / 86400000);
              console.log("maxとmin---------")
              console.log(min)
              console.log(max)
              console.log(difminmax)
              console.log("------------------")
              //⑤minにfor文で足した日付(YYYY/MM/DD)をdatesに格納してカレンダー反映
              var a = min
              var b = max
              for (let i = 0; i <= difminmax; i++) {
                console.log(a)
                var c = this.getParticularPlusDate(a, a.getHours(),a.getMinutes(),i)
                console.log(c)
                var d = this.getDateStringFromDate(c)
                console.log(d)
                this.dates.push(d)
              }
              //#selectedtestDateに候補を"YYYY/MM/DD HH:DD~"で選択肢<option></option>を追加する
              ////minとmaxの間の15分を足していく(その際営業時間外出ないかチェックをする)
              ////minとmaxの日付の15分単位差分
              //var difminmaxBy15 = Math.floor((max - min) / 900000);
              var difminmaxBy15 = Math.floor((max - min) / 1800000);
              console.log(difminmaxBy15)

              let element = document.getElementById("selectedtestDate");
              while (element.firstChild) {
                element.removeChild(element.firstChild);
              }

              for (let m = 0; m <= difminmaxBy15; m++) {
                var selectValue = this.getParticularPlusMinute(min,m*30)

                //ここでスクリーニング
                if (selectValue.getHours() === 8 && selectValue.getMinutes() < 30) {
                } else if (selectValue.getHours() < 8) {
                } else if (selectValue.getHours() > 17) {
                } else {
                  //その時間帯がmin

                  selft.selectDates.push(selectValue)
                  var selectValueString = this.getDateHourMinuteStringFromDate(selectValue)

                  var select = document.getElementById("selectedtestDate")
                  var option = document.createElement("option")
                  option.text = selectValueString
                  option.value = selectValueString
                  self.dateStrings.push(selectValueString);
                  select.appendChild(option)
                }
              }
            }
          }
        }
      }
    },
    getParticularDate: function (date, hour,minute, minus) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate()-minus, hour, minute, 0)
    },
    getParticularPlusDate: function (date, hour,minute, plus) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate()+plus, hour, minute, 0)
    },
    getParticularPlusMinute: function (date, plus) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 60+plus, 0)
    },
    getDateStringFromDate: function (date) {
      var y = date.getFullYear()
      var m = ('00' + (date.getMonth() + 1)).slice(-2)
      var d = ('00' + date.getDate()).slice(-2)
      var result =  y + '-' + m + '-' + d
      return result
    },
    getDateHourMinuteStringFromDate: function (date) {
      var y = date.getFullYear()
      var m = ('00' + (date.getMonth() + 1)).slice(-2)
      var d = ('00' + date.getDate()).slice(-2)
      var h = ('00' + date.getHours()).slice(-2)
      var mi = ('00' + date.getMinutes()).slice(-2)
      var result =  y + '-' + m + '-' + d + ' '  + h + ':' + mi + '〜'
      return result
    },
    selectTestDate: function () {
         //選択されている日付が配列の中で何番目か計算
      console.log('-----AA------------');
      console.log(this.testDate);
      let num = this.dateStrings.indexOf(this.testDate)
      console.log(num);
      console.log('-----------------');

      let hour24 = this.selectDates[num].getHours();
      console.log(hour24)
      if (hour24 < 12) {
        this.isCampaign = false
      } else {
        this.isCampaign = true
      }
    },
    toform: function () {
      // #form非表示、#confirm表示
      document.getElementById('confirm').style.display = "none";
      document.getElementById('form').style.display = "block";
    },
    toconfirm: function () {

      let self = this
      if (!this.checked) {
        alert('キャンセルポリシーに同意してから確認するボタンを押してください。')
        return
      }
      if (this.amount) {
        if (this.amount == "7名以上") {
          alert('検査人数が7名以上の場合は、TOPページのLineからご相談ください。')
          return
        }
      }
      // バリデーション
      if (!this.name) {
        alert('氏名が入力されてません、入力してから確認するボタンを押してください。')
        return
      }
      if (!this.tel) {
        alert('電話番号が入力されてません、入力してから確認するボタンを押してください。')
        return
      }
      if (!this.passport) {
        alert('パスポート番号が入力されてません、入力してから確認するボタンを押してください。')
        return
      }
      if (!this.mail) {
        alert('メールアドレスが入力されてません、入力してから確認するボタンを押してください。')
        return
      }

      //入力フォーマット
      const regex = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
      if (regex.test(this.mail)) {

      } else {
        alert('メールアドレスが入力が正しくありません、正しく入力してから確認するボタンを押してください。')
        return
      }

      //半角or全角
      if (this.mail.match(/[^A-Za-z0-9]+/)) {      

      } else {
        //半角英数字以外
        alert('メールアドレスが入力が正しくありません、半角英数字で入力してから確認するボタンを押してください。')
        return
      }
        

      if (!this.amount) {
        alert('検査人数が選択されてません、選択してから確認するボタンを押してください。')
        return
      }
      if (!this.place) {
        alert('検査場所が選択されてません、選択してから確認するボタンを押してください。')
        return
      }
      //date-confirmにテキスト表示
      console.log( $('.vdp-datepicker > div > input'))
      this.dateString = $('.vdp-datepicker > div > input').val()
      if (!this.dateString) {
        alert('帰国日が選択されてません、選択してから確認するボタンを押してください。')
        return
      }
      if (!this.hour && !this.minute) {
        alert('帰国便出発予定時間が選択されてません、選択してから確認するボタンを押してください。')
        return
      }
      if (!this.testDate) {
        alert('検査希望日時が選択されてません、選択してから確認するボタンを押してください。')
        return
      }


      // ここでプラン条件分岐
      if (this.test == "通常検査(6時間以内)") {
        if (self.amount == 1) {
        this.price = 145 + "ドル"
        this.verprice = 14500
        }
        if (self.amount == 2) {
           this.price = 290 + "ドル"
           this.verprice = 14500
        }
        if (self.amount == 3) {
         this.price = 435 + "ドル"
         this.verprice = 14500
        }
        if (self.amount == 4) {
          
         this.price = 580 + "ドル"
         this.verprice = 14500
        }
        if (self.amount == 5) {
          this.price = 725 + "ドル"
          this.verprice = 14500
        }
        if (self.amount == 6) {
         this.price = 870 + "ドル"
         this.verprice = 14500
        }
        if (self.amount == "7人以上") {
          
        }
      } else {
        if (self.amount == 1) {
        this.price = 160 + "ドル"
        this.verprice = 16000
        }
        if (self.amount == 2) {
           this.price = 320 + "ドル"
           this.verprice = 16000
        }
        if (self.amount == 3) {
         this.price = 480 + "ドル"
         this.verprice = 16000
        }
        if (self.amount == 4) {
          
         this.price = 640 + "ドル"
         this.verprice = 16000
        }
        if (self.amount == 5) {
          this.price = 800 + "ドル"
          this.verprice = 16000
        }
        if (self.amount == 6) 
         this.price = 960 + "ドル"
         this.verprice = 16000
        }
        if (self.amount == "7人以上") {
          
        }

      

     
      
      // #form非表示、#confirm表示
      document.getElementById('form').style.display = "none";
      document.getElementById('confirm').style.display = "block";
    },
    tosend: function () {

      console.log("BB")


      /*メール送信(本当は決済完了後...ここは改修必要あり)*/

      //var baseURL = "https://weart-marketing.com/api/hawaii/contact/";
      var baseURL = "https://weart-marketing.com/api/hawaii/contacttest/";
     
      let self = this
      console.log("--こここここここ-")
          console.log("---------------")
          console.log(self.amount)
          console.log(self.verprice)
          console.log("---------------")

      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < 16; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      this.id = text

      var baseURL = "";
      if (self.place == "ワイキキ") {

        console.log("--こここここここ-")
          console.log("---------------")
          console.log(self.amount)
          console.log(self.verprice)
          console.log("---------------")
          var data2 = { 'name': self.name, 'tel': self.tel, 'mail': self.mail, 'place': self.place, 'date': self.dateString, 'hour': self.hour, 'minute': self.minute, 'testDate': self.testDate, 'airplane': self.airplane, 'memo': self.memo, 'passport': self.passport, 'amount': self.amount, 'customers': self.customers, 'price': self.price, 'id': self.id,'verprice': self.verprice,'test': self.test };

          $.ajax({
          　url: 'https://weart-marketing.com/api/hawaii/campaign3/paytest/createsession/index.php', //アクセスするURLかディレクトリ
          　type: 'get',
          　cache: false, //cacheを使うかどうか
          　data:data2, //アクセスするときに必要なデータを 記載
          　})
          　.done(function(response) { //通信が成功したときのコールバックの処理を書く
            console.log("response")
            console.log(response)
             console.log(response.session_id)

             var t = JSON.parse(response);
             console.log(t['session_id'])

              // 実行したい処理を書く
        //const stripe = window.Stripe("pk_test_51Kd3ZEIj8wf5HWpIHvf6l4IYlyJ3fauAq4QpVs5xjFCJINgGeowAR7WOw1paYp4TY62Vsh8py6yyI0i91h6gyzSL00iC0CexhM"); 

        const stripe = window.Stripe("pk_live_51Kd3ZEIj8wf5HWpIUDcG8GeOqn3wO1cXbGddCAGIHsFramYh1o25OoAubHlwAWaXl5Eh25sFscDll9zpyUBqZaiH00AKlNMTEf"); 

         stripe.redirectToCheckout({
          sessionId: t['session_id']
}).then(function (result) {
  console.log("ここ読み込まれる")
  　　console.log(result)
     // エラー処理
     // `result.error.message`を使うと、ブラウザの言語に合わせたエラーメッセージを表示することができる
});
          　})
          　.fail(function(xhr) { //通信が失敗したときのコールバックの処理を書く
            console.log("xhr")
            console.log(xhr)
          　})
          　.always(function(xhr, msg) { //通信結果にかかわらず実行する処理を書く
             console.log("msg")
          });

      } else {
        if (self.amount == "1") {
          baseURL = "https://weart-marketing.com/api/hawaii/pay7/";
        }
        if (self.amount == "2") {
          baseURL = "https://weart-marketing.com/api/hawaii/pay8/";
        }
        if (self.amount == "3") {
          baseURL = "https://weart-marketing.com/api/hawaii/pay9/";
        }
        if (self.amount == "4") {
          baseURL = "https://weart-marketing.com/api/hawaii/pay10/";
        }
        if (self.amount == "5") {
          baseURL = "https://weart-marketing.com/api/hawaii/pay11/";
        }
        if (self.amount == "6") {
          baseURL = "https://weart-marketing.com/api/hawaii/pay12/";
        }
        if (self.amount == "7人以上") {
          
        }
      }

    }
  },
  mounted() {

    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)

    this.tomorrow = tomorrow

    const result = document.getElementsByClassName('vdp-datepicker');

            var input = result[0].querySelector('input');

            //スマホなのかwebなのか
            if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
              input.style = "border: 1px solid #ddd;border-radius: 6px;margin-left: 0px;padding-left: 1em;padding-right: 1em;height: 48px;flex: 1;width: 100%;max-width: 410px;background: #eaedf2;font-size: 18px;";
            } else {
              input.style = "border: 1px solid #ddd;border-radius: 6px;margin-left: 40px;padding-left: 1em;padding-right: 1em;height: 48px;flex: 1;width: 100%;max-width: 410px;background: #eaedf2;font-size: 18px;";
            }
      }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#confirm-btn{
  opacity: 0.6;
 /* pointer-events: none;*/
}
/*
.confirm-btn-disable{
  pointer-events: auto!important;
}*/
.box {
  width: 90%;
    height: 200px;
    padding: 0px 5%;
  border: 1px solid #000;      /* わかりやすくボーダーを引く */
  overflow-y: scroll; 
  margin: 5% auto;         /* 縦方向にスクロール可能にする */
}
.policy{
  text-align: left;
  margin:5% auto;
}
h1{
  font-family: M PLUS Rounded\ 1c,sans-serif;
  font-weight: bolder!important;
}
h1, h2 {
  font-weight: normal;
  margin: 0px!important;
}
a{text-decoration: none;}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
}
.step-content4 a{
  color: #196FB9;
}
#place a{
   color: #196FB9;
}
h1 img{
  width: 100%!important;
}
body{
  margin: 0 auto!important;
}
header{
  background: #196FB9;
}
.spnone{
  display: block;
}
.pcnone{
  display: none;
}
h1{
padding: 16px;
}
.main-visual img{width: 100%;}
.header-top-inner{
  display: flex;
  justify-content: space-between;
  padding: 16px;
  padding-top: 0px;
  padding-bottom: 0px;
  color: white;
}
.header-top-inner .item{
  color: white;
}
.header-bottom-inner {
  display: flex;
  margin: 0 auto;
  width: 60%;
}
.header-bottom-inner .item{
  width: 50%;
}
.feature{
}
.feature h2{

    font-size: 2em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    text-align: center;
    width: 100%;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;
}
.contact h2{

    font-size: 2em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    text-align: center;
    width: 100%;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;

}

/* CTA_05 */

.cta05-cvset {
    padding: 100px 0 0;
    width: 90%;
    margin: 0 auto;
}

.cta05-cvset .cta05-inner {
    background-color: #f4fcf4;
    padding: 10px 0 20px;
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
}

.cta05-cvset .cta05-inner ul {
    list-style:none;
    margin-top: 40px;
    padding-inline-start:0;
    border: none;
    padding: 0;
}

.cta05-cvset-title {
    position: relative;
    font-size: 1.8em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    position: absolute;
    top: -10px;
    left: 0;
    text-align: center;
    width: 100%;
}
.cta05-cvset-title .deco {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;
}

.cta05-cvset-title .deco:before, .cta05-cvset-title .deco:after {
    display: inline-block;
    position: absolute;
    top: 42%;
    width: 28px;
    height: 2px;
    border-radius: 3px;
    background-color: coral;
    content: "";
    margin: auto -35px;
}
.cta05-cvset-title .deco:before {
    left: 0;
    -webkit-transform: rotate(50deg);
    transform: rotate(50deg);
}

.cta05-cvset-title .deco:after {
    right: 0;
    -webkit-transform: rotate(-50deg);
    transform: rotate(-50deg);
}

.cta05-cvset-list {
    display: flex;
    width: 100%;
    max-width: 780px;
    justify-content: space-between;
    margin: 0 auto;
}
.cta05-cvset-list li {
    max-width: 360px;
    width: 100%;
    margin: 0 5px;
}
.cta05-cvset-list img {
    width:100%;
    text-align:center;
}
.cta05-button.dwl, .cta05-button.etm {
    background-color: #fff;
    border: 3px solid #005fa0;
    color: #005fa0;
}
.cta05-button.dwl, .cta05-button.dmo, .cta05-button.etm {
    height: 56px;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.4em;
    text-align: center;
    flex-direction: column;
    white-space: nowrap;
    text-decoration: none;
}
.cta05-button.dmo {
    background: linear-gradient(#217669, #224364);
    border: 0px solid #005fa0;
    color: #fff;
    width: 80%;
    margin: 5% auto;
}
.cta05-button {
    position: relative;
    display: flex;
    width: 100%;
    height: 72px;
    text-align: center;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border-radius: 12px;
    margin: 0;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 6px 10px -2px rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.2);
    transition: 0.2s ease-in-out;
}
.cta05-button.free::after {
    content: "無料";
    position: absolute;
    display: block;
    top: -17px;
    right: 8px;
    width: 80px;
    height: 30px;
    font-size: 16px;
    font-weight: bold;
    line-height: 32px;
    text-align: center;
    background-color: coral;
    color: #fff;
    border-radius: 16px;
}
.cta05-button.dwl:hover, .cta05-button.dmo:hover, .cta05-button.etm:hover {
    background-color: #6bb6ff;
    box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.15), 0 0 5px rgba(0, 0, 0, 0.1);
    transform: translateY(-4px);
}
.cta05-button.dwl small, .cta05-button.dmo small, .cta05-button.etm small {
    display: block;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2em;
    letter-spacing: 0;
    margin-bottom: 4px;
    white-space: nowrap;
}
.cta05-cvset-list span{
  font-weight: 700;
}
@media screen and (max-width: 768px){
.cta05-cvset .cta05-inner {
    padding: 40px 20px 32px;
}
.cta05-cvset-list {
    flex-direction: column;
    align-items: center;
    padding-bottom: 16px;
}
.cta05-button.dwl small, .cta05-button.dmo small, .cta05-button.etm small {
    font-size: 12px;
}
}
/* container */
.wrapper{
    width:100%;
    background-color:transparent;
}
.wrapper .container{
    max-width:1000px;
    margin:0px auto;
    padding:80px 0px;
}
/* content */
@media (min-width: 992px) {
    .wrapper .container .content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90%;
    margin: 0 auto;
    }
}
.wrapper .content-item {
    width:100%;
}
@media (min-width: 992px) {
    .wrapper .content-item {
        width:50%;
    }
}
.wrapper .image{
    display:block;
    max-width:100%;
    margin:0px auto;
}
.wrapper .text{
    padding:50px;
}
.wrapper .text .heading{
    margin:0px 0px 40px 0px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}
/* container */
.wrapper2{
    width:100%;
    background-color:transparent;
}
.wrapper2 .container{
    max-width:1000px;
    margin:0px auto;
    padding:80px 0px;
}
/* content */
@media (min-width: 992px) {
    .wrapper2 .container .content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90%;
    margin: 0 auto;
    }
}
/* PC時のみ順番を入れ替える */
@media (min-width: 992px) {
    .wrapper2 .content {
        flex-direction:row-reverse;
    }
}
.wrapper 2.content-item {
    width:100%;
}
@media (min-width: 992px) {
    .wrapper2 .content-item {
        width:50%;
    }
}
.wrapper2 .image{
    display:block;
    max-width:100%;
    margin:0px auto;
}
.wrapper2 .text{
    padding:50px;
}
.wrapper2 .text .heading{
    margin:0px 0px 40px 0px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}
.text p{
  line-height: 2em;
}

@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700);

#feedback-page{
  text-align:center;
}

#form-main{
  width:100%;
  float:left;
  padding-top:0px;
}

#form-div {
  background-color: rgba(72,72,72,0.4);
    padding-left: 35px;
    padding-right: 35px;
    padding-top: 35px;
    padding-bottom: 50px;
    width: 80%;
    /* float: left; */
    display: block;
    /* left: 50%; */
    margin: 0 auto;
    /* position: absolute; */
    margin-top: 30px;
    /* margin-left: -260px; */
    -moz-border-radius: 7px;
    -webkit-border-radius: 7px;
}

.feedback-input {
  color:#3c3c3c;
  font-family: Helvetica, Arial, sans-serif;
  font-weight:500;
  font-size: 18px;
  border-radius: 0;
  line-height: 22px;
  background-color: #fbfbfb;
  padding: 13px 13px 13px 13px;
  margin-bottom: 10px;
  width:100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  border: 3px solid rgba(0,0,0,0);
}

.feedback-input:focus{
  background: #fff;
  box-shadow: 0;
  border: 3px solid #3498db;
  color: #3498db;
  outline: none;
  padding: 13px 13px 13px 13px;
}

.focused{
  color:#30aed6;
  border:#30aed6 solid 3px;
}

/* Icons ---------------------------------- */
#name{
  background-image: url(http://rexkirby.com/kirbyandson/images/name.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#name:focus{
  background-image: url(http://rexkirby.com/kirbyandson/images/name.svg);
  background-size: 30px 30px;
  background-position: 8px 5px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#email{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#email:focus{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#comment{
  background-image: url(http://rexkirby.com/kirbyandson/images/comment.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#date{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}
#date:focus{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}
textarea {
    width: 100%;
    height: 150px;
    line-height: 150%;
    resize:vertical;
}
input:hover, textarea:hover,
input:focus, textarea:focus {
 opacity: 0.7;
}
#button-blue{
  font-family: 'Montserrat', Arial, Helvetica, sans-serif;
  float:left;
  width: 100%;
  border: #fbfbfb solid 4px;
  cursor:pointer;
  background: linear-gradient(#217669, #224364);
  color:white;
  font-size:24px;
  padding-top:22px;
  padding-bottom:22px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  margin-top:-4px;
  font-weight:700;
}

#button-blue:hover{
  opacity: 0.7;
}
.submit:hover {
  opacity: 0.7;
}
.ease {
  width: 0px;
  height: 74px;
  background-color: #fbfbfb;
  -webkit-transition: .3s ease;
  -moz-transition: .3s ease;
  -o-transition: .3s ease;
  -ms-transition: .3s ease;
  transition: .3s ease;
}

.submit:hover .ease{
  width:100%;
  background-color:white;
}

@media only screen and (max-width: 580px) {
  #form-div{
    left: 3%;
    margin-right: 3%;
    width: 88%;
    margin-left: 0;
    padding-left: 3%;
    padding-right: 3%;
  }
}
.contact{
  background-color:transparent;
}
.form-inner{
  background-color:transparent;
}
@media only screen and (max-width: 1080px) {
body {
    width: 100%!important;
}
.spnone{
  display: none;
}
.pcnone{
  display: block;
}
.wrapper .container {
    padding: 0px;
}
.wrapper {
    margin-top: 10%;
    }
.wrapper2 .container {
    padding: 0px;
}
#form-div {
    left: 0%;
    margin-right: initial;
    width: 88%;
    display: block;
    margin: 10% auto;
}
.cta05-cvset .cta05-inner {
    padding: 16px;
}
.cta05-cvset .cta05-inner {
  width: initial;
  }
  .cta05-cvset-title {
    font-size: 1.2em;
    top: -5px;
  }
}
.header-bottom-inner{display: flex; width: 80%; justify-content: space-between;color: white; font-weight: bold;}
.header-bottom-inner .btn-inner{display: contents;}
.header-bottom-inner .item{width: 80%;margin: 16px auto;font-size: 1.2em;border-radius: 20px;}
.selected {background: #5b97cd;}
.content{display: none;}
.show{display: block;}
.feature{padding: 5%;}
.feature-inner{display: flex;justify-content: space-between;}
.fea{width: 23%;}
.fa, .fas {font-size: 3em;color: #196FB9;}
h2{
  position: relative;
    font-family: "M PLUS Rounded 1c", sans-serif;
    font-weight: bold;
    color: #196FB9;
    text-align: center;
    font-size: 2rem;
    margin: 93px 0 40px;
    padding: 0 20px 30px;
}
h2:after {
    position: absolute;
    bottom: 0;
    left: 50%;
    display: block;
    content: "";
    width: 80px;
    height: 5px;
    background-color: #196FB9;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    -webkit-transform: translate(-50%, 0);
    -moz-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
}
.service table{
  margin: 2% auto;
  width: 60%;
}
.table th {
    border-top: 1px solid #fff;
    background-color: #196FB9;
    text-align: center;
    color: #fff;
    padding: 15px;
}
.table td {
    border-top: 1px solid #fff;
    border-left: 1px solid #fff;
    background-color: #F1F7FC;
    color: #196FB9;
    padding: 15px 40px;
    text-align: left;
}
.table .key{
  width: 30%;
}
.service .description{text-align: left;width: 60%; margin:16px auto;}
.flow-inner{ width: 50%;margin: 0 auto;}
.place-inner{ display: flex;justify-content: space-between;width: 60%;margin: 0 auto;  }
.place-info{margin: 5% auto;}
.pla{width: 50%;}
.pla img{width: 100%;}
.place-info table{
  margin: 0 auto;
  width: 60%;
}
.place-info .first{margin-bottom: 5%;}
.service{margin-bottom: 5%;}
.flow{margin-bottom: 5%;}
.place{margin-bottom: 5%;}
.feature{margin-bottom: 5%;}
.contact-btn{
  background: orange;
    border-radius: 20px;
    padding: 8px;
    padding-left: 36px;
    padding-right: 36px;
    letter-spacing: .2em;
}
.two{
  padding: 24px;
    text-align: left;
}
.two .title{
  font-size: 1.5em;
    font-weight: bold;
    color: #196FB9;
}
@media only screen and (max-width: 1080px) {
  .step-body4 img{
    width: 100%;
  }
  .flow-inner {
    width: 90%;
  }
  .service .description {
    width: 90%;
  }
  .service table {
    width: 90%;
  }
  .place-inner {
     width: 90%;
   }
   .feature-inner{
    display: block;
   }
   .fea {
    width: 80%;
    margin: 10% auto;
}
.cv{display: none;}
table th,
table td{

  width:100%;

  display:block;
  width: 90%;

}
.table td {
    padding: 0px;
    width: 100%;

}
.table .key {
    width: 92%;
}
.place-inner {
    width: 90%;
    display: block;
}
.pla {
    width: 100%;
}
.place-info table {
    margin: 0 auto;
    width: 90%;
}
.first .table td {
    padding: 0px;
    width: 98%;
}
.two {
    padding: 0px;
    margin: 5% auto;
    text-align: left;

}
.place-info .first {
    margin-bottom: 15%;
}
.place {
    margin-bottom: 15%;
}
.service {
    margin-bottom: 15%;
}
.flow {
    margin-bottom: 15%;
}
}

/***ステップバーデザイン4***/
.step-wrap4 {
 counter-reset: count;
 margin: 2em 0;
 position: relative;
}
.step-content4 {
 padding: 1em 0 1.3em 2.5em;
 margin: 0;
 text-align: left;
 position: relative;
}
.step-content4::before {
 content: "";
 display: block;
 width: 55px;
 height: 55px;
 background: #759bcc;
 border-radius: 50%;
 position: absolute;
 top: 0;
 left: -3px;
}
.step-content4::after {
 content: "";
 display: block;
 height: calc(100% - 55px);
 border-left: solid 2px #ddd;
 position: absolute;
 top: 55px;
 left: 10px;
}
.step-label4 {
 color: #fff;
 font-weight: bold;
 font-size: 12px;
 position: absolute;
 top: 6px;
 left: 9px;
}
.step-label4::after {
 counter-increment: count;
 content: counter(count);
 position: absolute;
 font-size: 30px;
 top: 8px;
 left: 7px;
}
.step-title4 {
 font-weight: bold;
 font-size: 120%;
 margin-left: 1.5em;
}
.step-body4 {
 margin-top: 1em;
 padding: 0 0 1em;
 border-bottom: dotted 2px #ddd;
}
.step-wrap4 > :last-of-type::after {
 display: none;
}
.Form {
  margin-top: 80px;
  margin-left: auto;
  margin-right: auto;
  max-width: 720px;
   margin-bottom: 5%;
}

@media screen and (max-width: 480px) {
  .Form {
    margin-top: 40px;
  }
}
.Form-Item {
  border-top: 1px solid #ddd;
  padding-top: 24px;
  padding-bottom: 24px;
  width: 100%;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 480px) {
  .Form-Item {
    flex-wrap: wrap;
  }
}
.Form-Item:nth-child(5) {
  border-bottom: 1px solid #ddd;
}
.Form-Item-Label {
  width: 100%;
  max-width: 248px;
  letter-spacing: 0.05em;
  font-weight: bold;
  font-size: 18px;
  text-align: left;
    padding-left: 5%;
}
@media screen and (max-width: 480px) {
  .Form-Item-Label {
    max-width: inherit;
    display: flex;
    align-items: center;
    font-size: 15px;
  }
}
.Form-Item-Label.isMsg {
  margin-top: 8px;
  margin-bottom: auto;
}
@media screen and (max-width: 480px) {
  .Form-Item-Label.isMsg {
    margin-top: 0;
  }
}
.Form-Item-Label-Required {
  border-radius: 6px;
  margin-right: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  width: 48px;
  display: inline-block;
  text-align: center;
  background: #196FB9;
  color: #fff;
  font-size: 14px;
}
@media screen and (max-width: 480px) {
  .Form-Item-Label-Required {
    border-radius: 4px;
    padding-top: 4px;
    padding-bottom: 4px;
    width: 32px;
    font-size: 10px;
  }
}
.Form-Item-Input {
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-left: 40px;
  padding-left: 1em;
  padding-right: 1em;
  height: 48px;
  flex: 1;
  width: 100%;
  max-width: 410px;
  background: #eaedf2;
  font-size: 18px;
}
@media screen and (max-width: 480px) {
  .Form-Item-Input {
    margin-left: 0;
    margin-top: 18px;
    height: 40px;
    flex: inherit;
    font-size: 15px;
  }
}
.Form-Item-Textarea {
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-left: 40px;
  padding-left: 1em;
  padding-right: 1em;
  height: 216px;
  flex: 1;
  width: 100%;
  max-width: 410px;
  background: #eaedf2;
  font-size: 18px;
}
@media screen and (max-width: 480px) {
  .Form-Item-Textarea {
    margin-top: 18px;
    margin-left: 0;
    height: 200px;
    flex: inherit;
    font-size: 15px;
  }
}
.Form-Btn {
  border-radius: 6px;
  margin-top: 32px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 280px;
  display: block;
  letter-spacing: 0.05em;
  background: #196FB9;
  color: #fff;
  border: 0px;
  font-weight: bold;
  font-size: 20px;
}
@media screen and (max-width: 480px) {
  .Form-Btn {
    margin-top: 24px;
    padding-top: 8px;
    padding-bottom: 8px;
    width: 160px;
    font-size: 16px;
  }
}
h2{
  padding-top: 2em;
}
#content01 img{
width: 50%;
    margin-top: 5%;
}
.Form {
    margin-top: 0px;
  }
  .vc-container {
    margin-left: 40px;
  }
  #selectedtestDate{
    margin:5% auto;
    margin-left: 320px;
    width: 100%;
    margin-top: 0px;
  }
  #content01 img {
    margin: 5% auto;
}
#form {display: block;}
#confirm{display: none;}

#confirm table{
  margin: 2% auto;
  width: 100%;
}
.table th {
    border-top: 1px solid #fff;
    background-color: #196FB9;
    text-align: center;
    color: #fff;
    padding: 15px;
}
.table td {
    border-top: 1px solid #fff;
    border-left: 1px solid #fff;
    background-color: #F1F7FC;
    color: #196FB9;
    padding: 15px 40px;
    text-align: left;
}
.table .key{
  width: 30%;
}
#aramoana{
  display: none;
}
.vc-font-medium {
    font-weight: 500;
    color: red;
  }
#card-num .Form-Item-Input {
  padding-left: 0em;
  padding-right: 0em;

}
@media only screen and (max-width: 1080px) {
.table td {
  display: contents;
}

  .Form {
    margin-bottom: 5%;
    padding: 5%;
    margin-top: 0px;
  }
  .vc-container {
    margin-left: 0px;
  }
  #content01 img{width: 100%;}
  .header-top-inner{
  display: none;
}
#selectedtestDate {
    margin: 5% auto;
    margin-left: 0px;
    width: 100%;
    margin-top: 0px;
}
#card-num .Form-Item-Input {
  margin-left: 8px;
  flex: initial;
  width: 20%;
}
}



.number{
  display: flex;
    background: orange;
    padding: 8px;
    width: fit-content;
    color: white;
    font-weight: bold;
    text-align: center;
}
</style>

<!--<template>
  <div class="main-contents">

    <header>
      <div class="header-top-inner">
        <a href="/">
          <div class="item">
            <h1>ハワイPCR検査センター</h1>
         
          </div>
        </a>
        <div class="item cv">
          <ul>
            <a href="tel:03-6384-0230"><li>お急ぎの方はこちら</li></a>
            <a href="/contact"><li class="contact-btn">お申し込み</li></a>
          </ul>
        </div>
      </div>
    
    </header>
    <div id="content01" class="content show">
      <h2>ご申込フォーム</h2>
      <div id="waikiki">
        <img src="../assets/mv-sp.png" class="pcnone">
        <img src="../assets/mv-pc.png" class="spnone">
      </div>
      <div id="aramoana">
        <img src="../assets/mv-sp.png" class="pcnone">
        <img src="../assets/mv-pc.png" class="spnone">
       
      </div>
      <p class="caution">※帰国日時や希望日時は現地時刻を意味します。</p>
      <form action="#" method="post" onsubmit="return false;">
         <div class="Form" id="form">
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>氏名</p>
            <input type="text" v-model="name" name="name" class="Form-Item-Input" placeholder="例）山田太郎">
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>電話番号</p>
            <input type="text" v-model="tel" name="tel" class="Form-Item-Input" placeholder="例）000-0000-0000">
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>メールアドレス</p>
            <input type="email" name="mail" v-model="mail" class="Form-Item-Input" placeholder="例）example@gmail.com" >
          </div>
      
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>検査場所</p>
            <select name="place" id="" class="Form-Item-Input" @change="selectplace" v-model="place">
                <option value="ワイキキ">ワイキキ</option>
                <option value="アラモアナ">アラモアナ</option>
            </select>
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>帰国日</p>
            <vuejs-datepicker
    :language="ja"
    v-model="date"
    :value="this.default"
    :format="DatePickerFormat"
    :id="el"
    @closed="dateselected"
     ></vuejs-datepicker>
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>帰国便出発予定時間</p>
            <div class="time" style="text-align: left;width: inherit;">
              <select name="selecthour" id="selectedate-h" class="Form-Item-Input" style="width: 30%;" @change="selecthour" v-model="hour">
                <option value="00">00</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
              </select>時
              <select name="selectminute" id="selectedate-m" class="Form-Item-Input" style="width: 30%;" @change="selectminute" v-model="minute">
                <option value="00">00</option>
                <option value="05">05</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
                <option value="35">35</option>
                <option value="40">40</option>
                <option value="45">45</option>
                <option value="50">50</option>
                <option value="55">55</option>
              </select>分
            </div>
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label">帰国便名</p>
            <input type="text" name="airplane" class="Form-Item-Input" placeholder="例）JL071" v-model="airplane">
          </div>
         
          <div class="Form-Item">
            <p class="Form-Item-Label"><span class="Form-Item-Label-Required">必須</span>検査希望日時</p>
            <v-calendar :disabled-dates='{}' :available-dates="dates"></v-calendar>
          </div>
          <div class="">
              <p style="font-weight: bold; color: orange;">上記カレンダーの太字が当日を除く、帰国前72時間以内の範囲で受検可能なお日にちになります。<br>以下の選択肢からご希望検査日時をお選びください。</p>
              <p v-html="alert" style="font-weight: bold; color: red;"></p>
              <div class="time-button-inner">
                <div class="">
                  <select name="selectedtestDate" id="selectedtestDate" class="Form-Item-Input"  @change="selectTestDate" v-model="testDate">
                  </select>
                </div>
              </div>
          </div>
          <div class="Form-Item">
            <p class="Form-Item-Label isMsg">その他備考</p>
            <textarea class="Form-Item-Textarea" name="memo" v-model="memo"></textarea>
          </div>
          <button v-on:click="toconfirm" class="Form-Btn">確認する</button>
          <a href="/" style="color: gray;margin: 5% auto;display: block;">トップへ戻る</a>
        </div>
         <div class="Form" id="confirm">
          <table class="table">
            <tr>
              <th>氏名</th>
              <td>{{ name }}</td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td>{{ tel }}</td>
            </tr>
            <tr>
              <th>メールアドレス</th>
              <td>{{ mail }}</td>
            </tr>
            <tr>
              <th>検査場所</th>
              <td>{{ place }}</td>
            </tr>
            <tr>
              <th>帰国日</th>
              <td id="date-confirm">{{ dateString }}</td>
            </tr>
            <tr>
              <th>帰国便出発予定時間</th>
              <td>{{ hour }} ： {{ minute }}</td>
            </tr>
            <tr>
              <th>帰国便名</th>
              <td>{{ airplane }}</td>
            </tr>
            <tr>
              <th>検査希望日時</th>
              <td>{{ testDate }}</td>
            </tr>
            <tr>
              <th>その他備考</th>
              <td>{{ memo }}</td>
            </tr>
          </table>

          <button v-on:click="tosend" class="Form-Btn">送信する</button>
          <button v-on:click="toform" class="Form-Btn">前へ戻る</button>
          <a href="/" style="color: gray; margin: 5% auto;display: block;">トップへ戻る</a>
        </div>
      </form>
    </div>
    <div id="content02" class="content">
    </div>
    <footer style="text-align: center;">
      Copyright © 2022 Kirarin.Co.,Ltd.
    </footer>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/vue/2.6.10/vue.min.js"></script>
<script src='https://unpkg.com/v-calendar'></script>

<script src="https://cdn.jsdelivr.net/npm/fullcalendar@5.5.0/main.min.js"></script>
<script type="text/javascript">
  window.onload = function(){
    // contentクラスの1つ目にshowを入れる
    document.getElementById("content01").classList.add("show");
  }
</script>

<script>
import vuejsDatepicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale'
export default {
  name: 'Top',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      default: '2018-10-04',
      ja:ja,
      name: '',
      tel: '',
      mail: '',
      date: null,
      dateString: '',
      place: '',
      hour: '--',
      minute: '--',
      airplane: '入力なし',
      memo: '',
      DatePickerFormat: 'yyyy-MM-dd',
      selectedDate: new Date(),
      testDate: null,
      dates: [],
      alert: '',
      attrs: [
          {
            key: 'today',
            highlight: {
              backgroundColor: '#ff8080',
            },
            dates:new Date()
            ,
            popover: {
              label: 'メッセージを表示できます',
            },
          }
      ],
      mode: 'single',
      formats: {
          input: ['YYYY-MM-DD'],
      }
    }
  },
  components: {
    'vuejs-datepicker':vuejsDatepicker
  },
  methods: {
    btn01: function () {
      document.getElementById("btn02").classList.remove("selected");
      document.getElementById("btn01").classList.add("selected");
      document.getElementById("content01").classList.add("show");
      document.getElementById("content02").classList.remove("show");
    },
    btn02: function () {
      document.getElementById("btn01").classList.remove("selected");
      document.getElementById("btn02").classList.add("selected");
      document.getElementById("content01").classList.remove("show");
      document.getElementById("content02").classList.add("show");
    },
    dateselected: function () {
      //console.log(this.date)
      // 帰国日・場所・帰国便出発予定時間からカレンダーの選択できる時間を自動指定
      //datesに可能な日にちを"YYYY-MM-DD"の文字列でで配列追加
      this.setAvailableDates()
      console.log(this.selectedDate)

    },
    selectplace: function () {
      //console.log(this.place)
      //datesに可能な日にちを"YYYY-MM-DD"の文字列でで配列追加
      //ワイキキ
      if (this.place === "ワイキキ") {
        document.getElementById("aramoana").style.display = "none";
        document.getElementById("waikiki").style.display = "block";
      } else {
        document.getElementById("waikiki").style.display = "none";
        document.getElementById("aramoana").style.display = "block";
      }
      //アラモアナ
      this.setAvailableDates()
    },
    selecthour: function () {
      //console.log(this.hour)
      //datesに可能な日にちを"YYYY-MM-DD"の文字列でで配列追加
      this.setAvailableDates()
    },
    selectminute: function () {
      //console.log(this.minute)
      //datesに可能な日にちを"YYYY-MM-DD"の文字列でで配列追加
      this.setAvailableDates()
    },
    setAvailableDates: function () {
      //カレンダ配列クリア
      this.dates = []
      // 帰国日の指定があるかどうか
      if (!this.date) {
        console.log('帰国日の指定がありません')
        this.alert = '帰国日の指定がありません'
      } else {
        //場所が未指定なら午前・午後(8:30~18:00)
        if (this.place === '--選択してください--') {
          this.alert = '場所の指定がありません'
        }
        //場所がワイキキなら午後以降
        if (this.place === 'ワイキキ') {
          console.log(this.place)
          //時間未指定
          if (this.hour === '--') {
            this.alert = '帰国便出発予定時間の時の指定がありません'
          } else {
            if (this.minute === '--') {
              this.alert = '帰国便出発予定時間の分の指定がありません'
            } else {
              // カレンダー選択可能な日にちと時間を計算
              this.alert = ''
              var min = null
              var max = null
              ////帰国日時の24時間前から72時間の日付と時間を抽出(maxとmin)
              //①帰国日時の日付型を取得②帰国日時の72時間前と24時間前の日時を日付型で取得
              let getDateFor24 = this.getParticularDate(this.date, this.hour, this.minute, 1)
              let getDateFor72 = this.getParticularDate(this.date, this.hour, this.minute, 3)
              console.log(getDateFor24)
              console.log(getDateFor72)
              //③72時間前以前24時間前以降で営業時間内のminとmaxを抽出
              ////72時間前以前
              /////開始時間前または終了時間以降であれば翌日の8:30~にする
              //////8:00~8:29または0:00~7:00または18:00~0:00に含まれるかどうか含まれるのであれば
              if (getDateFor72.getHours() === 8 && getDateFor72.getMinutes() < 30) {
                //8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 0)
              } else if (getDateFor72.getHours() <= 8) {
                //8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 0)

              } else if (getDateFor72.getHours() > 17) {
                //翌日8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 1)

              } else {
                //その時間帯がmin
                min = getDateFor72
              }

              ////24時間前以降
              /////開始時間前または終了時間以降であれば前日の18:00にする
              if (getDateFor24.getHours() === 8 && getDateFor24.getMinutes() < 30) {
                //前日18:00がmax
                max = this.getParticularDate(getDateFor24, 18, 0, 0)
              } else if (getDateFor24.getHours() <= 8) {
                //前日18:00がmax
                max = this.getParticularDate(getDateFor24, 18, 0, 1)

              } else if (getDateFor24.getHours() > 17) {
                //当日18:00がmin
                max = this.getParticularPlusDate(getDateFor24, 18, 0, 0)

              } else {
                //その時間帯がmin
                max = getDateFor24
              }

              //④minとmaxの間の差分
              var difminmax = Math.floor((max - min) / 86400000);
              console.log("maxとmin---------")
              console.log(min)
              console.log(max)
              console.log(difminmax)
              console.log("------------------")
              //⑤minにfor文で足した日付(YYYY/MM/DD)をdatesに格納してカレンダー反映
              var a = min
              var b = max
              for (let i = 0; i <= difminmax; i++) {
                console.log(a)
                var c = this.getParticularPlusDate(a, a.getHours(),a.getMinutes(),i)
                console.log(c)
                var d = this.getDateStringFromDate(c)
                console.log(d)
                //id-2022-07-16
                this.dates.push(d)
              }
              //#selectedtestDateに候補を"YYYY/MM/DD HH:DD~"で選択肢<option></option>を追加する
              ////minとmaxの間の15分を足していく(その際営業時間外出ないかチェックをする)
              ////minとmaxの日付の15分単位差分
              //var difminmaxBy15 = Math.floor((max - min) / 900000);
              var difminmaxBy15 = Math.floor((max - min) / 1800000);
              console.log(difminmaxBy15)

              let element = document.getElementById("selectedtestDate");
              while (element.firstChild) {
                element.removeChild(element.firstChild);
              }

              for (let m = 0; m <= difminmaxBy15; m++) {
                var selectValue = this.getParticularPlusMinute(min,m*30)

                //ここでスクリーニング
                if (selectValue.getHours() === 8 && selectValue.getMinutes() < 30) {
                } else if (selectValue.getHours() < 8) {
                } else if (selectValue.getHours() > 17) {
                } else {
                  //その時間帯がmin
                  var selectValueString = this.getDateHourMinuteStringFromDate(selectValue)

                  var select = document.getElementById("selectedtestDate");
                  var option = document.createElement("option");
                  option.text = selectValueString;
                  option.value = selectValueString;
                  select.appendChild(option);
                }
              }
            }
          }
        }
        //場所がアラモアナなら終日OK
        if (this.place === 'アラモアナ') {
          console.log(this.place)
          //時間未指定
          if (this.hour === '--') {
            this.alert = '帰国便出発予定時間の時の指定がありません'
          } else {
            if (this.minute === '--') {
              this.alert = '帰国便出発予定時間の分の指定がありません'
            } else {
              // カレンダー選択可能な日にちと時間を計算
              this.alert = ''
              var min = null
              var max = null
              ////帰国日時の24時間前から72時間の日付と時間を抽出(maxとmin)
              //①帰国日時の日付型を取得②帰国日時の72時間前と24時間前の日時を日付型で取得
              let getDateFor24 = this.getParticularDate(this.date, this.hour, this.minute, 1)
              let getDateFor72 = this.getParticularDate(this.date, this.hour, this.minute, 3)
              console.log(getDateFor24)
              console.log(getDateFor72)
              //③72時間前以前24時間前以降で営業時間内のminとmaxを抽出
              ////72時間前以前
              /////開始時間前または終了時間以降であれば翌日の8:30~にする
              //////8:00~8:29または0:00~7:00または18:00~0:00に含まれるかどうか含まれるのであれば
              if (getDateFor72.getHours() === 8 && getDateFor72.getMinutes() < 30) {
                //8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 0)
              } else if (getDateFor72.getHours() <= 8) {
                //8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 0)

              } else if (getDateFor72.getHours() > 17) {
                //翌日8:30がmin
                min = this.getParticularPlusDate(getDateFor72, 8, 30, 1)

              } else {
                //その時間帯がmin
                min = getDateFor72
              }

              ////24時間前以降
              /////開始時間前または終了時間以降であれば前日の18:00にする
              if (getDateFor24.getHours() === 8 && getDateFor24.getMinutes() < 30) {
                //前日18:00がmax
                max = this.getParticularDate(getDateFor24, 18, 0, 0)
              } else if (getDateFor24.getHours() <= 8) {
                //前日18:00がmax
                max = this.getParticularDate(getDateFor24, 18, 0, 1)

              } else if (getDateFor24.getHours() > 17) {
                //当日18:00がmin
                max = this.getParticularPlusDate(getDateFor24, 18, 0, 0)

              } else {
                //その時間帯がmin
                max = getDateFor24
              }

              //④minとmaxの間の差分
              var difminmax = Math.floor((max - min) / 86400000);
              console.log("maxとmin---------")
              console.log(min)
              console.log(max)
              console.log(difminmax)
              console.log("------------------")
              //⑤minにfor文で足した日付(YYYY/MM/DD)をdatesに格納してカレンダー反映
              var a = min
              var b = max
              for (let i = 0; i <= difminmax; i++) {
                console.log(a)
                var c = this.getParticularPlusDate(a, a.getHours(),a.getMinutes(),i)
                console.log(c)
                var d = this.getDateStringFromDate(c)
                console.log(d)
                this.dates.push(d)
              }
              //#selectedtestDateに候補を"YYYY/MM/DD HH:DD~"で選択肢<option></option>を追加する
              ////minとmaxの間の15分を足していく(その際営業時間外出ないかチェックをする)
              ////minとmaxの日付の15分単位差分
              //var difminmaxBy15 = Math.floor((max - min) / 900000);
              var difminmaxBy15 = Math.floor((max - min) / 1800000);
              console.log(difminmaxBy15)

              let element = document.getElementById("selectedtestDate");
              while (element.firstChild) {
                element.removeChild(element.firstChild);
              }

              for (let m = 0; m <= difminmaxBy15; m++) {
                var selectValue = this.getParticularPlusMinute(min,m*30)

                //ここでスクリーニング
                if (selectValue.getHours() === 8 && selectValue.getMinutes() < 30) {
                } else if (selectValue.getHours() < 8) {
                } else if (selectValue.getHours() > 17) {
                } else {
                  //その時間帯がmin
                  var selectValueString = this.getDateHourMinuteStringFromDate(selectValue)

                  var select = document.getElementById("selectedtestDate")
                  var option = document.createElement("option")
                  option.text = selectValueString
                  option.value = selectValueString
                  select.appendChild(option)
                }
              }
            }
          }
        }
      }
    },
    getParticularDate: function (date, hour,minute, minus) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate()-minus, hour, minute, 0)
    },
    getParticularPlusDate: function (date, hour,minute, plus) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate()+plus, hour, minute, 0)
    },
    getParticularPlusMinute: function (date, plus) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()+plus, 0)
    },
    getDateStringFromDate: function (date) {
      var y = date.getFullYear()
      var m = ('00' + (date.getMonth() + 1)).slice(-2)
      var d = ('00' + date.getDate()).slice(-2)
      var result =  y + '-' + m + '-' + d
      return result
    },
    getDateHourMinuteStringFromDate: function (date) {
      var y = date.getFullYear()
      var m = ('00' + (date.getMonth() + 1)).slice(-2)
      var d = ('00' + date.getDate()).slice(-2)
      var h = ('00' + date.getHours()).slice(-2)
      var mi = ('00' + date.getMinutes()).slice(-2)
      var result =  y + '-' + m + '-' + d + ' '  + h + ':' + mi + '〜'
      return result
    },
    selectTestDate: function () {

    },
    toform: function () {
      // #form非表示、#confirm表示
      document.getElementById('confirm').style.display = "none";
      document.getElementById('form').style.display = "block";
    },
    toconfirm: function () {
      // バリデーション
      if (!this.name) {
        alert('氏名が入力されてません、入力してから確認するボタンを押してください。')
        return
      }
      if (!this.tel) {
        alert('電話番号が入力されてません、入力してから確認するボタンを押してください。')
        return
      }
      if (!this.mail) {
        alert('メールアドレスが入力されてません、入力してから確認するボタンを押してください。')
        return
      }
      if (!this.place) {
        alert('検査場所が選択されてません、選択してから確認するボタンを押してください。')
        return
      }
      //date-confirmにテキスト表示
      console.log( $('.vdp-datepicker > div > input'))
      this.dateString = $('.vdp-datepicker > div > input').val()
      if (!this.dateString) {
        alert('帰国日が選択されてません、選択してから確認するボタンを押してください。')
        return
      }
      if (!this.hour && !this.minute) {
        alert('帰国便出発予定時間が選択されてません、選択してから確認するボタンを押してください。')
        return
      }
      if (!this.testDate) {
        alert('検査希望日時が選択されてません、選択してから確認するボタンを押してください。')
        return
      }

      // #form非表示、#confirm表示
      document.getElementById('form').style.display = "none";
      document.getElementById('confirm').style.display = "block";
    },
    tosend: function () {

      console.log("AA")

      var baseURL = "https://weart-marketing.com/api/hawaii/contact/";
      //var param = "?name=" + this.name + "&tel=" + this.tel + "&mail=" + this.mail + "&place=" + this.place + "&date=" + this.dateString + "&hour=" + this.hour + "&minute=" + this.minute + "&testDate=" + this.testDate;
      //var URL = baseURL + param;
      //console.log(URL)
      let self = this

      var data = { 'name': this.name, 'tel': this.tel, 'mail': this.mail, 'place': this.place, 'date': this.dateString, 'hour': this.hour, 'minute': this.minute, 'testDate': this.testDate, 'airplane': this.airplane, 'memo': this.memo }
          $.ajax({
            url: baseURL,
            type: 'GET',
            data: data
          })
          .done(function (data) {
            //GETメソッドが成功した場合の処理
            //お問い合わせ完了ページ
            alert('お申し込み完了しました')
            location.href = "/contact/success?plan=" + self.place
          })
          .fail(function () {
           //GETメソッドが失敗した場合の処理
            alert('お申し込みに失敗しました。再度入力内容をご確認の上、お申し込みください')
          })
    }
  },
  mounted() {

    const result = document.getElementsByClassName('vdp-datepicker');

            var input = result[0].querySelector('input');

            //スマホなのかwebなのか
            if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
              input.style = "border: 1px solid #ddd;border-radius: 6px;margin-left: 0px;padding-left: 1em;padding-right: 1em;height: 48px;flex: 1;width: 100%;max-width: 410px;background: #eaedf2;font-size: 18px;";
            } else {
              input.style = "border: 1px solid #ddd;border-radius: 6px;margin-left: 40px;padding-left: 1em;padding-right: 1em;height: 48px;flex: 1;width: 100%;max-width: 410px;background: #eaedf2;font-size: 18px;";
            }
      }
}
</script>
<style scoped>
h1{
  font-family: M PLUS Rounded\ 1c,sans-serif;
  font-weight: bolder!important;
}
h1, h2 {
  font-weight: normal;
  margin: 0px!important;
}
a{text-decoration: none;}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
}
.step-content4 a{
  color: #196FB9;
}
#place a{
   color: #196FB9;
}
h1 img{
  width: 100%!important;
}
body{
  margin: 0 auto!important;
}
header{
  background: #196FB9;
}
.spnone{
  display: block;
}
.pcnone{
  display: none;
}
h1{
padding: 16px;
}
.main-visual img{width: 100%;}
.header-top-inner{
  display: flex;
  justify-content: space-between;
  padding: 16px;
  padding-top: 0px;
  padding-bottom: 0px;
  color: white;
}
.header-top-inner .item{
  color: white;
}
.header-bottom-inner {
  display: flex;
  margin: 0 auto;
  width: 60%;
}
.header-bottom-inner .item{
  width: 50%;
}
.feature{
}
.feature h2{

    font-size: 2em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    text-align: center;
    width: 100%;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;
}
.contact h2{

    font-size: 2em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    text-align: center;
    width: 100%;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;

}

/* CTA_05 */

.cta05-cvset {
    padding: 100px 0 0;
    width: 90%;
    margin: 0 auto;
}

.cta05-cvset .cta05-inner {
    background-color: #f4fcf4;
    padding: 10px 0 20px;
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
}

.cta05-cvset .cta05-inner ul {
    list-style:none;
    margin-top: 40px;
    padding-inline-start:0;
    border: none;
    padding: 0;
}

.cta05-cvset-title {
    position: relative;
    font-size: 1.8em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    position: absolute;
    top: -10px;
    left: 0;
    text-align: center;
    width: 100%;
}
.cta05-cvset-title .deco {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;
}

.cta05-cvset-title .deco:before, .cta05-cvset-title .deco:after {
    display: inline-block;
    position: absolute;
    top: 42%;
    width: 28px;
    height: 2px;
    border-radius: 3px;
    background-color: coral;
    content: "";
    margin: auto -35px;
}
.cta05-cvset-title .deco:before {
    left: 0;
    -webkit-transform: rotate(50deg);
    transform: rotate(50deg);
}

.cta05-cvset-title .deco:after {
    right: 0;
    -webkit-transform: rotate(-50deg);
    transform: rotate(-50deg);
}

.cta05-cvset-list {
    display: flex;
    width: 100%;
    max-width: 780px;
    justify-content: space-between;
    margin: 0 auto;
}
.cta05-cvset-list li {
    max-width: 360px;
    width: 100%;
    margin: 0 5px;
}
.cta05-cvset-list img {
    width:100%;
    text-align:center;
}
.cta05-button.dwl, .cta05-button.etm {
    background-color: #fff;
    border: 3px solid #005fa0;
    color: #005fa0;
}
.cta05-button.dwl, .cta05-button.dmo, .cta05-button.etm {
    height: 56px;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.4em;
    text-align: center;
    flex-direction: column;
    white-space: nowrap;
    text-decoration: none;
}
.cta05-button.dmo {
    background: linear-gradient(#217669, #224364);
    border: 0px solid #005fa0;
    color: #fff;
    width: 80%;
    margin: 5% auto;
}
.cta05-button {
    position: relative;
    display: flex;
    width: 100%;
    height: 72px;
    text-align: center;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border-radius: 12px;
    margin: 0;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 6px 10px -2px rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.2);
    transition: 0.2s ease-in-out;
}
.cta05-button.free::after {
    content: "無料";
    position: absolute;
    display: block;
    top: -17px;
    right: 8px;
    width: 80px;
    height: 30px;
    font-size: 16px;
    font-weight: bold;
    line-height: 32px;
    text-align: center;
    background-color: coral;
    color: #fff;
    border-radius: 16px;
}
.cta05-button.dwl:hover, .cta05-button.dmo:hover, .cta05-button.etm:hover {
    background-color: #6bb6ff;
    box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.15), 0 0 5px rgba(0, 0, 0, 0.1);
    transform: translateY(-4px);
}
.cta05-button.dwl small, .cta05-button.dmo small, .cta05-button.etm small {
    display: block;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2em;
    letter-spacing: 0;
    margin-bottom: 4px;
    white-space: nowrap;
}
.cta05-cvset-list span{
  font-weight: 700;
}
@media screen and (max-width: 768px){
.cta05-cvset .cta05-inner {
    padding: 40px 20px 32px;
}
.cta05-cvset-list {
    flex-direction: column;
    align-items: center;
    padding-bottom: 16px;
}
.cta05-button.dwl small, .cta05-button.dmo small, .cta05-button.etm small {
    font-size: 12px;
}
}
/* container */
.wrapper{
    width:100%;
    background-color:transparent;
}
.wrapper .container{
    max-width:1000px;
    margin:0px auto;
    padding:80px 0px;
}
/* content */
@media (min-width: 992px) {
    .wrapper .container .content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90%;
    margin: 0 auto;
    }
}
.wrapper .content-item {
    width:100%;
}
@media (min-width: 992px) {
    .wrapper .content-item {
        width:50%;
    }
}
.wrapper .image{
    display:block;
    max-width:100%;
    margin:0px auto;
}
.wrapper .text{
    padding:50px;
}
.wrapper .text .heading{
    margin:0px 0px 40px 0px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}
/* container */
.wrapper2{
    width:100%;
    background-color:transparent;
}
.wrapper2 .container{
    max-width:1000px;
    margin:0px auto;
    padding:80px 0px;
}
/* content */
@media (min-width: 992px) {
    .wrapper2 .container .content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90%;
    margin: 0 auto;
    }
}
/* PC時のみ順番を入れ替える */
@media (min-width: 992px) {
    .wrapper2 .content {
        flex-direction:row-reverse;
    }
}
.wrapper 2.content-item {
    width:100%;
}
@media (min-width: 992px) {
    .wrapper2 .content-item {
        width:50%;
    }
}
.wrapper2 .image{
    display:block;
    max-width:100%;
    margin:0px auto;
}
.wrapper2 .text{
    padding:50px;
}
.wrapper2 .text .heading{
    margin:0px 0px 40px 0px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}
.text p{
  line-height: 2em;
}

@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700);

#feedback-page{
  text-align:center;
}

#form-main{
  width:100%;
  float:left;
  padding-top:0px;
}

#form-div {
  background-color: rgba(72,72,72,0.4);
    padding-left: 35px;
    padding-right: 35px;
    padding-top: 35px;
    padding-bottom: 50px;
    width: 80%;
    /* float: left; */
    display: block;
    /* left: 50%; */
    margin: 0 auto;
    /* position: absolute; */
    margin-top: 30px;
    /* margin-left: -260px; */
    -moz-border-radius: 7px;
    -webkit-border-radius: 7px;
}

.feedback-input {
  color:#3c3c3c;
  font-family: Helvetica, Arial, sans-serif;
  font-weight:500;
  font-size: 18px;
  border-radius: 0;
  line-height: 22px;
  background-color: #fbfbfb;
  padding: 13px 13px 13px 13px;
  margin-bottom: 10px;
  width:100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  border: 3px solid rgba(0,0,0,0);
}

.feedback-input:focus{
  background: #fff;
  box-shadow: 0;
  border: 3px solid #3498db;
  color: #3498db;
  outline: none;
  padding: 13px 13px 13px 13px;
}

.focused{
  color:#30aed6;
  border:#30aed6 solid 3px;
}

/* Icons ---------------------------------- */
#name{
  background-image: url(http://rexkirby.com/kirbyandson/images/name.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#name:focus{
  background-image: url(http://rexkirby.com/kirbyandson/images/name.svg);
  background-size: 30px 30px;
  background-position: 8px 5px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#email{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#email:focus{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#comment{
  background-image: url(http://rexkirby.com/kirbyandson/images/comment.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#date{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}
#date:focus{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}
textarea {
    width: 100%;
    height: 150px;
    line-height: 150%;
    resize:vertical;
}
input:hover, textarea:hover,
input:focus, textarea:focus {
 opacity: 0.7;
}
#button-blue{
  font-family: 'Montserrat', Arial, Helvetica, sans-serif;
  float:left;
  width: 100%;
  border: #fbfbfb solid 4px;
  cursor:pointer;
  background: linear-gradient(#217669, #224364);
  color:white;
  font-size:24px;
  padding-top:22px;
  padding-bottom:22px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  margin-top:-4px;
  font-weight:700;
}

#button-blue:hover{
  opacity: 0.7;
}
.submit:hover {
  opacity: 0.7;
}
.ease {
  width: 0px;
  height: 74px;
  background-color: #fbfbfb;
  -webkit-transition: .3s ease;
  -moz-transition: .3s ease;
  -o-transition: .3s ease;
  -ms-transition: .3s ease;
  transition: .3s ease;
}

.submit:hover .ease{
  width:100%;
  background-color:white;
}

@media only screen and (max-width: 580px) {
  #form-div{
    left: 3%;
    margin-right: 3%;
    width: 88%;
    margin-left: 0;
    padding-left: 3%;
    padding-right: 3%;
  }
}
.contact{
  background-color:transparent;
}
.form-inner{
  background-color:transparent;
}
@media only screen and (max-width: 1080px) {
body {
    width: 100%!important;
}
.spnone{
  display: none;
}
.pcnone{
  display: block;
}
.wrapper .container {
    padding: 0px;
}
.wrapper {
    margin-top: 10%;
    }
.wrapper2 .container {
    padding: 0px;
}
#form-div {
    left: 0%;
    margin-right: initial;
    width: 88%;
    display: block;
    margin: 10% auto;
}
.cta05-cvset .cta05-inner {
    padding: 16px;
}
.cta05-cvset .cta05-inner {
  width: initial;
  }
  .cta05-cvset-title {
    font-size: 1.2em;
    top: -5px;
  }
}
.header-bottom-inner{display: flex; width: 80%; justify-content: space-between;color: white; font-weight: bold;}
.header-bottom-inner .btn-inner{display: contents;}
.header-bottom-inner .item{width: 80%;margin: 16px auto;font-size: 1.2em;border-radius: 20px;}
.selected {background: #5b97cd;}
.content{display: none;}
.show{display: block;}
.feature{padding: 5%;}
.feature-inner{display: flex;justify-content: space-between;}
.fea{width: 23%;}
.fa, .fas {font-size: 3em;color: #196FB9;}
h2{
  position: relative;
    font-family: "M PLUS Rounded 1c", sans-serif;
    font-weight: bold;
    color: #196FB9;
    text-align: center;
    font-size: 2rem;
    margin: 93px 0 40px;
    padding: 0 20px 30px;
}
h2:after {
    position: absolute;
    bottom: 0;
    left: 50%;
    display: block;
    content: "";
    width: 80px;
    height: 5px;
    background-color: #196FB9;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    -webkit-transform: translate(-50%, 0);
    -moz-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
}
.service table{
  margin: 2% auto;
  width: 60%;
}
.table th {
    border-top: 1px solid #fff;
    background-color: #196FB9;
    text-align: center;
    color: #fff;
    padding: 15px;
}
.table td {
    border-top: 1px solid #fff;
    border-left: 1px solid #fff;
    background-color: #F1F7FC;
    color: #196FB9;
    padding: 15px 40px;
    text-align: left;
}
.table .key{
  width: 30%;
}
.service .description{text-align: left;width: 60%; margin:16px auto;}
.flow-inner{ width: 50%;margin: 0 auto;}
.place-inner{ display: flex;justify-content: space-between;width: 60%;margin: 0 auto;  }
.place-info{margin: 5% auto;}
.pla{width: 50%;}
.pla img{width: 100%;}
.place-info table{
  margin: 0 auto;
  width: 60%;
}
.place-info .first{margin-bottom: 5%;}
.service{margin-bottom: 5%;}
.flow{margin-bottom: 5%;}
.place{margin-bottom: 5%;}
.feature{margin-bottom: 5%;}
.contact-btn{
  background: orange;
    border-radius: 20px;
    padding: 8px;
    padding-left: 36px;
    padding-right: 36px;
    letter-spacing: .2em;
}
.two{
  padding: 24px;
    text-align: left;
}
.two .title{
  font-size: 1.5em;
    font-weight: bold;
    color: #196FB9;
}
@media only screen and (max-width: 1080px) {
  .step-body4 img{
    width: 100%;
  }
  .flow-inner {
    width: 90%;
  }
  .service .description {
    width: 90%;
  }
  .service table {
    width: 90%;
  }
  .place-inner {
     width: 90%;
   }
   .feature-inner{
    display: block;
   }
   .fea {
    width: 80%;
    margin: 10% auto;
}
.cv{display: none;}
table th,
table td{

  width:100%;

  display:block;
  width: 90%;

}
.table td {
    padding: 0px;
    width: 100%;

}
.table .key {
    width: 92%;
}
.place-inner {
    width: 90%;
    display: block;
}
.pla {
    width: 100%;
}
.place-info table {
    margin: 0 auto;
    width: 90%;
}
.first .table td {
    padding: 0px;
    width: 98%;
}
.two {
    padding: 0px;
    margin: 5% auto;
    text-align: left;

}
.place-info .first {
    margin-bottom: 15%;
}
.place {
    margin-bottom: 15%;
}
.service {
    margin-bottom: 15%;
}
.flow {
    margin-bottom: 15%;
}
}

/***ステップバーデザイン4***/
.step-wrap4 {
 counter-reset: count;
 margin: 2em 0;
 position: relative;
}
.step-content4 {
 padding: 1em 0 1.3em 2.5em;
 margin: 0;
 text-align: left;
 position: relative;
}
.step-content4::before {
 content: "";
 display: block;
 width: 55px;
 height: 55px;
 background: #759bcc;
 border-radius: 50%;
 position: absolute;
 top: 0;
 left: -3px;
}
.step-content4::after {
 content: "";
 display: block;
 height: calc(100% - 55px);
 border-left: solid 2px #ddd;
 position: absolute;
 top: 55px;
 left: 10px;
}
.step-label4 {
 color: #fff;
 font-weight: bold;
 font-size: 12px;
 position: absolute;
 top: 6px;
 left: 9px;
}
.step-label4::after {
 counter-increment: count;
 content: counter(count);
 position: absolute;
 font-size: 30px;
 top: 8px;
 left: 7px;
}
.step-title4 {
 font-weight: bold;
 font-size: 120%;
 margin-left: 1.5em;
}
.step-body4 {
 margin-top: 1em;
 padding: 0 0 1em;
 border-bottom: dotted 2px #ddd;
}
.step-wrap4 > :last-of-type::after {
 display: none;
}
.Form {
  margin-top: 80px;
  margin-left: auto;
  margin-right: auto;
  max-width: 720px;
   margin-bottom: 5%;
}
@media screen and (max-width: 480px) {
  .Form {
    margin-top: 40px;
  }
}
.Form-Item {
  border-top: 1px solid #ddd;
  padding-top: 24px;
  padding-bottom: 24px;
  width: 100%;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 480px) {
  .Form-Item {
    flex-wrap: wrap;
  }
}
.Form-Item:nth-child(5) {
  border-bottom: 1px solid #ddd;
}
.Form-Item-Label {
  width: 100%;
  max-width: 248px;
  letter-spacing: 0.05em;
  font-weight: bold;
  font-size: 18px;
  text-align: left;
    padding-left: 5%;
}
@media screen and (max-width: 480px) {
  .Form-Item-Label {
    max-width: inherit;
    display: flex;
    align-items: center;
    font-size: 15px;
  }
}
.Form-Item-Label.isMsg {
  margin-top: 8px;
  margin-bottom: auto;
}
@media screen and (max-width: 480px) {
  .Form-Item-Label.isMsg {
    margin-top: 0;
  }
}
.Form-Item-Label-Required {
  border-radius: 6px;
  margin-right: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  width: 48px;
  display: inline-block;
  text-align: center;
  background: #196FB9;
  color: #fff;
  font-size: 14px;
}
@media screen and (max-width: 480px) {
  .Form-Item-Label-Required {
    border-radius: 4px;
    padding-top: 4px;
    padding-bottom: 4px;
    width: 32px;
    font-size: 10px;
  }
}
.Form-Item-Input {
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-left: 40px;
  padding-left: 1em;
  padding-right: 1em;
  height: 48px;
  flex: 1;
  width: 100%;
  max-width: 410px;
  background: #eaedf2;
  font-size: 18px;
}
@media screen and (max-width: 480px) {
  .Form-Item-Input {
    margin-left: 0;
    margin-top: 18px;
    height: 40px;
    flex: inherit;
    font-size: 15px;
  }
}
.Form-Item-Textarea {
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-left: 40px;
  padding-left: 1em;
  padding-right: 1em;
  height: 216px;
  flex: 1;
  width: 100%;
  max-width: 410px;
  background: #eaedf2;
  font-size: 18px;
}
@media screen and (max-width: 480px) {
  .Form-Item-Textarea {
    margin-top: 18px;
    margin-left: 0;
    height: 200px;
    flex: inherit;
    font-size: 15px;
  }
}
.Form-Btn {
  border-radius: 6px;
  margin-top: 32px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 280px;
  display: block;
  letter-spacing: 0.05em;
  background: #196FB9;
  color: #fff;
  border: 0px;
  font-weight: bold;
  font-size: 20px;
}
@media screen and (max-width: 480px) {
  .Form-Btn {
    margin-top: 24px;
    padding-top: 8px;
    padding-bottom: 8px;
    width: 160px;
    font-size: 16px;
  }
}
h2{
  padding-top: 2em;
}
#content01 img{
width: 50%;
    margin-top: 5%;
}
.Form {
    margin-top: 0px;
  }
  .vc-container {
    margin-left: 40px;
  }
  #selectedtestDate{
    margin:5% auto;
    margin-left: 320px;
    width: 100%;
    margin-top: 0px;
  }
  #content01 img {
    margin: 5% auto;
}
#form {display: block;}
#confirm{display: none;}

#confirm table{
  margin: 2% auto;
  width: 100%;
}
.table th {
    border-top: 1px solid #fff;
    background-color: #196FB9;
    text-align: center;
    color: #fff;
    padding: 15px;
}
.table td {
    border-top: 1px solid #fff;
    border-left: 1px solid #fff;
    background-color: #F1F7FC;
    color: #196FB9;
    padding: 15px 40px;
    text-align: left;
}
.table .key{
  width: 30%;
}
#aramoana{
  display: none;
}
.vc-font-medium {
    font-weight: 500;
    color: red;
  }
@media only screen and (max-width: 1080px) {
.table td {
  display: contents;
}

  .Form {
    margin-bottom: 5%;
    padding: 5%;
    margin-top: 0px;
  }
  .vc-container {
    margin-left: 0px;
  }
  #content01 img{width: 100%;}
  .header-top-inner{
  display: none;
}
#selectedtestDate {
    margin: 5% auto;
    margin-left: 0px;
    width: 100%;
    margin-top: 0px;
}
}
</style>-->



// WEBPACK FOOTER //
// src/components/Contact.vue